import 'react-app-polyfill/stable'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider as SC_ThemeProvider } from 'styled-components'
import { ConfiguratorProvider } from '@augmatica/iframe-interface-react'

import { DEFAULT, PRODUCT_PAGE } from './constants/constants'
import store from './store/store'
import { handleAppInit } from './store/init/initSlice'
import { setApiConfigs } from './store/requests/requestsSlice'
import App from './App'
import ProductPageApp from './ProductPageApp'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import reportWebVitals from './reportWebVitals'
import { getMuiTheme } from './getMuiTheme'
import * as Styled from './styles'

const DOM_ROOT_ID = 'mok-context-spa'

const rootElement = document.getElementById(DOM_ROOT_ID)
if (!rootElement) throw new Error(`React root element is missing: "${DOM_ROOT_ID}"`)

const applicationMode = rootElement.getAttribute('data-application-mode') ?? DEFAULT
const isDisabled = rootElement.hasAttribute('data-is-disabled')

const articleErpitemnumber = rootElement.getAttribute('data-article-erpitemnumber')
const articlePayoff = rootElement.getAttribute('data-article-payoff')

const channelId = rootElement.getAttribute('data-channel-id')

if (!channelId?.length) throw new Error('Scensum channel id is missing')

const marketCode = rootElement.getAttribute('data-market-code')
const locale = rootElement.getAttribute('data-language-code')

if (!marketCode) throw new Error('marketCode is missing')
if (!locale) throw new Error('languageCode is missing')

const languageCode = locale.replace('-', '_')

if (!languageCode.includes('_')) throw new Error('Unexpected format for languageCode')

const assetBaseUrl = rootElement.getAttribute('data-asset-base-url')
if (!assetBaseUrl) console.error('Scensum asset_baseurl is missing')

const productConfiguratorAdaptersScriptUrl = rootElement.getAttribute('data-product-configurator-adapters-script-url')
if (!productConfiguratorAdaptersScriptUrl) throw new Error('data-product-configurator-adapters-script-url is missing')

const productConfiguratorControllerScriptUrl = rootElement.getAttribute(
  'data-product-configurator-controller-script-url'
)
if (!productConfiguratorControllerScriptUrl)
  throw new Error('data-product-configurator-controller-script-url is missing')

const isStoreLoggedIn = rootElement.getAttribute('data-is-store-logged-in') === 'true'

store.dispatch(
  handleAppInit({
    applicationMode,
    channelId,
    marketCode,
    languageCode,
    assetBaseUrl,
    productConfiguratorAdaptersScriptUrl,
    productConfiguratorControllerScriptUrl,
    isStoreLoggedIn,
  })
)

store.dispatch(setApiConfigs({ channelId, marketCode, languageCode }))

const muiTheme = getMuiTheme(channelId)

const root = createRoot(rootElement)

root.render(
  // <React.StrictMode>
  <ErrorBoundary channelId={channelId}>
    <Provider store={store}>
      <Styled.globalStyles theme={muiTheme} />
      <MuiThemeProvider theme={muiTheme}>
        <SC_ThemeProvider theme={muiTheme}>
          {applicationMode === PRODUCT_PAGE ? (
            <ProductPageApp
              isDisabled={isDisabled}
              articleErpitemnumber={articleErpitemnumber ?? undefined}
              articlePayoff={articlePayoff ?? undefined}
            />
          ) : (
            <ConfiguratorProvider>
              <App />
            </ConfiguratorProvider>
          )}
        </SC_ThemeProvider>
      </MuiThemeProvider>
    </Provider>
  </ErrorBoundary>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
